import { createTheme } from "@mui/material/styles";
import MuiTooltip from "./mui-tooltip";
import palette from "./palette";
import typography from "./typography";
import MuiButton from "./mui-button";
import MuiOutlinedInput from "./mui-outlined-input";
import MuiFilledInput from "./mui-filled-input";
import MuiInputLabel from "./mui-input-label";
import MuiDivider from "./mui-divider";
import MuiTabs from "./mui-tabs";
import MuiTab from "./mui-tab";
import MuiTableContainer from "./mui-table-container";
import MuiFormHelperText from "./mui-form-helper-text";
import MuiListItemButton from "./mui-list-item-button";
import MuiCardHeader from "./mui-card-header";
import MuiAutocomplete from "./mui-autocomplete";
import MuiCardContent from "./mui-card-content";
import MuiInputAdornment from "./mui-input-adornment";
import MuiCardActions from "./mui-card-actions";
import MuiTextField from "./mui-text-field";
import MuiSelect from "./mui-select";
import MuiInputBase from "./mui-input-base";
import MuiAccordion from "./mui-accordion";
import MuiCard from "./mui-card";
import { MuiMenuItem } from "./mui-menu-item";
import { MuiMenu } from "./mui-menu";
import { MuiTableRow } from "./mui-table-row";
import { MuiTableHead } from "./mui-table-head";
import { MuiTableCell } from "./mui-table-cell";
import widths from "./widths";
import breakpoints from "./breakpoints";

const theme = createTheme({
  palette,
  typography,
  widths,
  breakpoints,
  components: {
    MuiButton,
    MuiOutlinedInput,
    MuiFilledInput,
    MuiInputLabel,
    MuiTabs,
    MuiTab,
    MuiTableContainer,
    MuiInputBase,
    MuiListItemButton,
    MuiCardHeader,
    MuiCardContent,
    MuiCardActions,
    MuiDivider,
    MuiFormHelperText,
    MuiSelect,
    MuiMenu,
    MuiMenuItem,
    MuiAccordion,
    MuiCard,
    MuiTextField,
    MuiInputAdornment,
    MuiAutocomplete,
    MuiTooltip,
    MuiTableRow,
    MuiTableHead,
    MuiTableCell,
  },
});

export default theme;
